export const NS_LIBS_CMDB_UTILS = "libs-cmdb-utils";

export enum K {
  CREATE = "CREATE",
  EDIT = "EDIT",
  DELETE = "DELETE",
  ACTIVE = "ACTIVE",
  ARCHIVE = "ARCHIVE",
  AUTOMATIC_DISCOVERY = "AUTOMATIC_DISCOVERY",
  CREATE_IN_BATCHES = "CREATE_IN_BATCHES",
  EDIT_IN_BATCHES = "EDIT_IN_BATCHES",
  INSTANCE = "INSTANCE",
  INSTANCE_RELATION = "INSTANCE_RELATION",
  OBJECT = "OBJECT",
  OBJECT_ATTRIBUTE = "OBJECT_ATTRIBUTE",
  OBJECT_RELATION = "OBJECT_RELATION",
  RELATION_GROUP = "RELATION_GROUP",
}

export type Locale = { [key in K]: string };
